import { isEmpty } from 'lodash'
import React, { useRef } from 'react'
import { get, useFormContext } from 'react-hook-form'
import tw from 'twin.macro'
import type { TSelectProps } from './interface'
import { StyledSelect } from './styles'

const BrandFormSelect = (props: TSelectProps) => {
  const {
    id,
    label,
    name,
    required = true,
    disabled,
    isError,
    errorMessage,
    children,
    fieldRef,
    onBlur,
    onChange,
  } = props
  const ref = useRef<HTMLSelectElement | null>(null)

  return (
    <div tw="flex flex-col justify-center">
      <StyledSelect
        id={id}
        name={name}
        aria-label={label}
        disabled={disabled}
        required={required}
        ref={(e) => {
          fieldRef?.(e)
          ref.current = e
        }}
        css={[
          (isError || !!errorMessage) &&
            tw`border-[0.5px] border-error bg-white text-error hover:bg-white active:bg-white focus-visible:bg-white`,
        ]}
        onBlur={onBlur}
        onChange={onChange}
      >
        {children}
      </StyledSelect>
      {errorMessage && <div tw="text-error font-body text-sm ml-6">{errorMessage}</div>}
    </div>
  )
}

export const ReactHookBrandFormSelect = (props: TSelectProps) => {
  const { name, required, children, requiredMessage = '' } = props
  const fieldWrapperRef = useRef(null)
  const { register, formState } = useFormContext()
  const errors = get(formState.errors, name)
  const errMsg = errors?.message ?? undefined
  const { ref, ...rest } = register(name, {
    required: required ? requiredMessage : false,
  })

  return (
    <BrandFormSelect
      fieldRef={(e: null) => {
        ref(e)
        fieldWrapperRef.current = e
      }}
      {...rest}
      {...props}
      isError={!isEmpty(errMsg)}
      errorMessage={errMsg}
    >
      {children}
    </BrandFormSelect>
  )
}

export default BrandFormSelect
